import './DeviceList.scss'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Tooltip, Alert, Button, Card, Col, Container, Form, ListGroup, Modal, Row, Badge } from 'react-bootstrap'
import { useTranslation } from 'react-i18next';
import { Devices } from '../../api/Devices';
import { useNavigate } from 'react-router-dom';
import AppLoader from '../../components/AppLoader';
import AppSearch from '../../components/AppSearch';
//import IconButton from '../../components/IconButton';
import { useFullScreenLoader } from '../../contexts/fullScreenLoader';
import { useToasts } from '../../contexts/toasts';
import { Device, DeviceType } from '../../models/Device';
import { Organization } from '../../models/Organization';
import { Organizations } from '../../api/Organizations';
import Avatar from '../../components/Avatar';
import { useAuth } from '../../contexts/auth';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

export default function DevicesList() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [devices, setDevices] = useState<Device[] | null>();
  const [deviceTypes, setDeviceTypes] = useState<DeviceType[] | null>();

  const [organizations, setOrganizations] = useState<Organization[]>();

  const [newDevice, setNewDevice] = useState<Device>({} as Device);
  const [deviceToDelete, setDeviceToDelete] = useState<Device>();
  const [editing, setEditing] = useState<number | undefined>();
  const [searchText, setSearchText] = useState<string>("");
  const [typeFilter, setTypeFilter] = useState<string | undefined>("0");
  const [organizationFilter, setOrganizationFilter] = useState<string | undefined>("0");
  const [statusFilter, setStatusFilter] = useState<string | "">("0");

  const [validated, setValidated] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  const [showAssignTenantModal, setShowAssignTenantModal] = useState<boolean>(false);
  const [showStatusModal, setShowStatusModal] = useState<boolean>(false);

  const { showLoader, hideLoader } = useFullScreenLoader();
  const { showToast } = useToasts();

  const { token } = useAuth();

  let oldDevices: Device[]

  useEffect(() => {
    initDevices();
    initDeviceTypes();
    initTenants();
    // eslint-disable-next-line
  }, []);

  const openCreateModal = () => {
    setEditing(undefined);
    setShowEditModal(true);
    setNewDevice({} as Device)
  }

  const handleDeleteModalClose = () => setShowDeleteModal(false);

  const handleCreateModalClose = () => {
    setShowEditModal(false);
    setValidated(false);
    setNewDevice({} as Device);
  }

  const handleSetStatusModalClose = () => {
    setShowStatusModal(false);
    setValidated(false);
    setNewDevice({} as Device);
  }

  const openDeleteModal = (device: Device) => () => {
    setShowDeleteModal(true);
    setDeviceToDelete(device);
  }

  const reset = () => {
    setDevices(null);
    initDevices();
  }

  const softReset = () => {
    //setDevices(null);
    setDevices([...oldDevices])
  }

  const handleAssignTenantModalClose = () => {
    setShowAssignTenantModal(false);
    softReset();
    setNewDevice({} as Device);
    if (editing !== undefined) setEditing(undefined);
    //initDevices();
    handleCreateModalClose();
  }

  const setAvatar = (device: Device) => {

    if (device?.deleted)
      return (
        <div className='pe-3'>
          <div className={`avatar md`}>{<FontAwesomeIcon className="text-danger" icon={solid('trash')} />}</div>
        </div>
      )

    switch (device?.status) {
      case 'ok':
        return (
          <div className='pe-3'>
            <div className={`avatar md`}>{<FontAwesomeIcon className="text-success" icon={solid('check')} />}</div>
          </div>
        )
      case 'unavailable':
        return (
          <div className='pe-3'>
            <div className={`avatar md`}>{<FontAwesomeIcon className="text-warning" icon={solid('ban')} />}</div>
          </div>
        )
      case 'crashed':
        return (
          <div className='pe-3'>
            <div className={`avatar md`}>{<FontAwesomeIcon className="text-danger" icon={solid('explosion')} />}</div>
          </div>
        )
    }

  }

  const handleSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.stopPropagation();
    evt.preventDefault();
    setValidated(true);

    if (!newDevice?.deviceTypeId && newDevice?.deviceType?.id)
      newDevice.deviceTypeId = newDevice?.deviceType.id

    if (form.checkValidity() === true) {
      showLoader!();

      const promise = editing as number >= 0 || showStatusModal
        ? Devices.updateDevice(newDevice)
        : Devices.createDevice(newDevice);

      promise
        .then(
          () => {
            hideLoader!();
            showToast!('device-success', `Device ${editing !== undefined ? 'Updated' : 'Created'} successfully`, 'Success', 'success');
            reset();
            setNewDevice({} as Device);
            handleCreateModalClose();
            handleSetStatusModalClose();
            if (editing !== undefined) setEditing(undefined);
          },
          (err) => {
            const message = err.response?.data?.message || err.message;
            const status = err.response?.status;
            hideLoader!();
            showToast!('device-error', message, `Devices Error ${status ? `(${status})` : ''}`, 'danger');
          }
        )
    }

  }

  const handleStatusChange = (evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.stopPropagation();
    evt.preventDefault();

    Devices.changeStaus(newDevice.id, newDevice.status).then(
      () => {
        hideLoader!();
        showToast!('device-success', `Device ${editing !== undefined ? 'Updated' : 'Created'} successfully`, 'Success', 'success');
        reset();
        setNewDevice({} as Device);
        handleSetStatusModalClose();
        if (editing !== undefined) setEditing(undefined);
      },
      (err) => {
        const message = err.response?.data?.message || err.message;
        const status = err.response?.status;
        hideLoader!();
        showToast!('device-error', message, `Devices Error ${status ? `(${status})` : ''}`, 'danger');
      }
    )
  }

  const handleAssignTenantSubmit = (evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.stopPropagation();
    evt.preventDefault();
    setValidated(true);

    if (form.checkValidity() === true) {
      showLoader!();

      const promise = Devices.assignTenant(newDevice.id.toString(), newDevice.organization.tenantId);

      promise
        .then(
          () => {
            hideLoader!();
            showToast!('device-success', `Tenant assigned successfully`, 'Success', 'success');
            initDevices();
            setShowAssignTenantModal(false);
            setNewDevice({} as Device);
            if (editing !== undefined) setEditing(undefined);
            //initDevices();
            handleCreateModalClose();
          },
          (err) => {
            const message = err.response?.data?.message || err.message;
            const status = err.response?.status;
            hideLoader!();
            showToast!('device-error', message, `Devices Error ${status ? `(${status})` : ''}`, 'danger');
          }
        )
    }
  }

  const handleFieldChange = (field: keyof Device) => (evt: React.ChangeEvent<any>) => {
    let value
    if (evt.target?.value)
      value = field == "deviceTypeId" ? parseInt(evt.target?.value) : evt.target?.value;
    setNewDevice({
      ...newDevice,
      [field]: value,
    })
  }

  const handleChekedOrganization = (organizationIndex: number) => (evt: React.ChangeEvent<any>) => {

    if (devices) oldDevices = [...devices]

    const value = evt.target.checked;

    let updatedOrganizations = [...organizations!]
    for (let i in updatedOrganizations)
      updatedOrganizations[i].checked = value && parseInt(i) == organizationIndex;

    if (organizations![organizationIndex].checked)
      newDevice.organization = organizations![organizationIndex]

    setOrganizations([...updatedOrganizations])

    setNewDevice({
      ...newDevice
    })

  }


  const deleteDevice = () => {
    showLoader!();

    Devices.deleteDevice(deviceToDelete!.id!.toString())
      .then(
        () => {
          hideLoader!();
          showToast!('device-success', 'Device deleted successfully', 'Delete Success', 'success');
          handleDeleteModalClose();
          reset();
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          hideLoader!();
          showToast!('device-error', message, `Devices Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }

  const editDevice = (index: number) => () => {
    setShowEditModal(true);
    setEditing(index);
    console.log(index)
    const device = { ...devices![index] }
    setNewDevice({
      ...device!,
      deviceTypeId: device?.deviceType?.id
    });
  }

  const changeStatus = (index: number) => () => {
    setShowStatusModal(true);
    setEditing(index);
    setNewDevice({ ...devices![index] });
  }

  const assignTenantToDevice = (index: number) => () => {
    setShowAssignTenantModal(true)
    setEditing(index);
    setNewDevice({ ...devices![index] });
  }

  const initDevices = () => {
    Devices.getDevicesList()
      .then(
        ({ data: devices }) => {
          setDevices(devices)
          //setDevices(devices.filter((device: Device) => !device.deleted))
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          hideLoader!();
          showToast!('devices-error', message, `Devices Error ${status ? `(${status})` : ''}`, 'danger');
        }
      );
  }

  const initDeviceTypes = () => {
    Devices.getDeviceTypesList()
      .then(
        ({ data: devices }) => {
          setDeviceTypes(devices)
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          hideLoader!();
          showToast!('devices-error', message, `Devices Error ${status ? `(${status})` : ''}`, 'danger');
        }
      );
  }

  const initTenants = () => {
    Organizations.getOrganizations()
      .then(
        ({ data: organizations }) => {
          organizations.map((o) => {
            o.checked = false;
            return o
          });
          setOrganizations(organizations);
        },
        (err) => {
          const message = err.response?.data?.message || err.message;
          const status = err.response?.status;
          showToast!('organizations-error', message, `Organizations Error ${status ? `(${status})` : ''}`, 'danger');
        }
      )
  }


  const handleFilterChange = (filter: 'search' | 'type' | 'organization' | 'status') => (evt: React.ChangeEvent<any>) => {
    let value = evt.target.value;

    switch (filter) {
      case 'search': default: setSearchText(value); return;
      case 'type': setTypeFilter(value); return;
      case 'organization': setOrganizationFilter(value); return;
      case 'status': setStatusFilter(value); return;
    }
  }


  const renderDevices = () => {

    const filteredDevices: Device[] = devices!
      .filter(dev => dev.label.toLowerCase().includes(searchText.toLowerCase()))
      .filter(dev => statusFilter === "0" ? true : (dev.status === statusFilter && dev.deleted === false))
      .filter(dev => typeFilter === "0" ? true :  dev.deviceType.id == Number(typeFilter))
      .filter(dev => Number(organizationFilter) == 0 ? true : organizationFilter == '-1' ? dev.organization == undefined : dev.organization?.id == Number(organizationFilter));


    return (
      <>
        <Row className="gx-2 mb-3">
          <Col>
            <AppSearch value={searchText} onChange={handleFilterChange('search')} placeholder={t('devicesList.search')} />
          </Col>
          <Col md={3}>
            <Form.Select size="sm" value={typeFilter} onChange={handleFilterChange('type')}>
              <option value="0">{t('devicesList.allTypes')}</option>
              {deviceTypes?.map(dev => (
                <option key={dev.id} value={dev.id}>{dev.name}</option>
              ))}
            </Form.Select>
          </Col>
          <Col md={3}>
            <Form.Select size="sm" value={statusFilter} onChange={handleFilterChange('status')}>
              <option value="0">{t('devicesList.allStatus')}</option>
              <option value='ok'>ok</option>
              <option value='unavailable'>unavailable</option>
              <option value='crashed'>crashed</option>

            </Form.Select>
          </Col>
          <Col md={3}>
            <Form.Select size="sm" value={organizationFilter} onChange={handleFilterChange('organization')}>
              <option value="0">{t('devicesList.allOrganizations')}</option>
              <option value="-1">{t('devicesList.notAssigned')}</option>
              {organizations?.map(org => (
                <option key={org.id} value={org.id}>{org.name}</option>
              ))}
            </Form.Select>
          </Col>

        </Row>

        {filteredDevices.length === 0 && (
          <Alert className="mb-0 py-2">
            <FontAwesomeIcon icon={solid('info-circle')} />
            <span className="ms-2">{t('devicesList.noDevices')}</span>
          </Alert>
        )}

        <ListGroup>
          {filteredDevices.map((device, index) => (
            <ListGroup.Item key={device?.id} className="d-flex align-items-center">
              <Col className="overflow-hidden d-flex align-items-center">
                <div>{setAvatar(device)}</div>
                <div>
                  <p className="mb-0 highlight h6" onClick={() => navigate(`/devices/${device?.id}/details`)}> {device?.label} </p>
                  <p className="text-truncate mb-0"><strong>ID:</strong> {device?.id}</p>
                  <Badge bg="success" className="border justify-self-end">
                    <span className="">{device?.deviceType.name}</span>
                  </Badge>
                  {device?.organization?.name && <Badge bg="light" className="ms-2 border justify-self-end text-muted">
                    <span className="">{device?.organization?.name}</span>
                  </Badge>}
                </div>

              </Col>

              <Col className="ps-3 text-end">
                {!device?.deleted && <>
                  <OverlayTrigger placement={"top"} overlay={<Tooltip id={`tooltip-edit`}>Edit device.</Tooltip>}>
                    <button className="icon-button" onClick={editDevice(index)} ><FontAwesomeIcon icon={solid('pen')} /></button>
                  </OverlayTrigger>

                  <OverlayTrigger placement={"top"} overlay={<Tooltip id={`tooltip-status`}>Change status</Tooltip>}>
                    <button className="ms-2 icon-button" onClick={changeStatus(index)}><FontAwesomeIcon icon={solid('gear')} /></button>
                  </OverlayTrigger>

                  <OverlayTrigger placement={"top"} overlay={<Tooltip id={`tooltip-tenant`}>Assign tenant</Tooltip>}>
                    <button className="ms-2 icon-button" onClick={assignTenantToDevice(index)}> <FontAwesomeIcon icon={solid('link')} /></button>
                  </OverlayTrigger>

                  <OverlayTrigger placement={"top"} overlay={<Tooltip id={`tooltip-delete`}>Delete</Tooltip>}>
                    <button className="ms-2 icon-button text-danger" onClick={openDeleteModal(device)}><FontAwesomeIcon icon={solid('trash')} /></button>
                  </OverlayTrigger>
                </>
                }
              </Col>
            </ListGroup.Item>
          ))}
        </ListGroup>
      </>
    )
  }

  const renderAsyncContent = () => {
    return devices
      ? renderDevices()
      : (
        <div className="d-flex justify-content-center py-5">
          <AppLoader size={150} />
        </div>
      )
  }

  const getDeviceTypeNameList = () => {
    let deviceTypesNameList = []
    if (deviceTypes)
      for (let deviceType of deviceTypes!)
        deviceTypesNameList.push(<option key={deviceType.id} value={deviceType.id}>{deviceType.name}</option>)
    return deviceTypesNameList
  }

  return (
    <Container>
      <Card>
        <div className="d-flex align-items-center justify-content-between border-bottom py-2 px-3">
          <Card.Title className="mb-0">{t('devicesList.title')}</Card.Title>

          <div>
            <Button className="ms-3" variant="success" size="sm" onClick={openCreateModal}>
              <FontAwesomeIcon icon={solid('plus')} />
              <span className="ms-2">{t('devicesList.create')}</span>
            </Button>
          </div>
        </div>

        <Card.Body>{renderAsyncContent()}</Card.Body>
      </Card>

      <Modal show={showDeleteModal} onHide={handleDeleteModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('common.deleteTitle', { item: t('common.device') })}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {t('devicesList.deleteMessage')} <b>{deviceToDelete?.label}</b>?

          <h5 className="my-4 text-center text-danger">{t('common.deleteWarning')}</h5>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" className="border" size="sm" onClick={handleDeleteModalClose}>{t('common.cancel')}</Button>
          <Button variant="danger" size="sm" onClick={deleteDevice}>{t('common.delete')}</Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showStatusModal} onHide={handleSetStatusModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('deviceEdit.editStatus')}</Modal.Title>
        </Modal.Header>

        <Form validated={validated} noValidate onSubmit={handleStatusChange}>
          <Modal.Body>

            <Form.Group controlId="device-status" className="mb-3">
              <Form.Label>{t('deviceEdit.deviceStatus')}</Form.Label>
              <Form.Select size="sm" value={newDevice?.status} onChange={handleFieldChange('status')}>
                <option value="">{t('deviceEdit.selectStatus')}</option>
                <option key="OK" value="ok">{t('deviceEdit.ok')}</option>
                <option key="UNAVAILABLE" value="unavailable">{t('deviceEdit.unavailable')}</option>
                <option key="CRASHED" value="crashed">{t('deviceEdit.crashed')}</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">{t('errors.requiredField', { field: t('deviceEdit.deviceStatus') })}</Form.Control.Feedback>
            </Form.Group>

          </Modal.Body>

          <Modal.Footer>
            <Button variant="light" className="border" size="sm" onClick={handleSetStatusModalClose}>{t('common.cancel')}</Button>
            <Button variant="success" size="sm" type="submit">{t('common.confirm')}</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showEditModal} onHide={handleCreateModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{editing !== undefined ? t('common.edit') : t('common.create')} {t('common.device')}</Modal.Title>
        </Modal.Header>

        <Form validated={validated} noValidate onSubmit={handleSubmit}>
          <Modal.Body>

            <Form.Group controlId="device-label" className="mb-3">
              <Form.Label>{t('devices.label')}</Form.Label>
              <Form.Control as="input" placeholder={t('deviceEdit.deviceLabel')} size="sm" value={newDevice?.label} onChange={handleFieldChange('label')} />
            </Form.Group>

            <Form.Group controlId="device-os" className="mb-3">
              <Form.Label>{t('devices.os')}</Form.Label>
              <Form.Control as="input" placeholder={t('deviceEdit.deviceOs')} size="sm" value={newDevice.os} onChange={handleFieldChange('os')} />
            </Form.Group>

            <Form.Group controlId="device-version-os" className="mb-3">
              <Form.Label>{t('devices.versionOs')}</Form.Label>
              <Form.Control as="input" placeholder={t('deviceEdit.versionOs')} size="sm" value={newDevice.versionOs} onChange={handleFieldChange('versionOs')} />
            </Form.Group>

            <Form.Group controlId="device-macAddress" className="mb-3">
              <Form.Label>{t('devices.macAddress')}</Form.Label>
              <Form.Control as="input" placeholder={t('deviceEdit.codeId')} size="sm" value={newDevice.codeId} onChange={handleFieldChange('codeId')} />
            </Form.Group>

            <Form.Group controlId="device-type" className="mb-3">
              <Form.Label>{t('deviceEdit.deviceType')}</Form.Label>
              <Form.Select size="sm" value={newDevice?.deviceTypeId} onChange={handleFieldChange('deviceTypeId')}>
                <option value="">{t('deviceEdit.selectDeviceType')}</option>
                {getDeviceTypeNameList()}
              </Form.Select>
            </Form.Group>

          </Modal.Body>

          <Modal.Footer>
            <Button variant="light" className="border" size="sm" onClick={handleCreateModalClose}>{t('common.cancel')}</Button>
            <Button variant="success" size="sm" type="submit">{t('common.confirm')}</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showAssignTenantModal} onHide={handleAssignTenantModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>{t('devicesList.assignTenant')}</Modal.Title>
        </Modal.Header>

        <Form validated={validated} noValidate onSubmit={handleAssignTenantSubmit}>
          <Modal.Body>
            <ListGroup>
              {organizations ? organizations!.map((organizations, index) => (
                <ListGroup.Item key={organizations.id} className="d-flex align-items-center">
                  <div className="pe-3">
                    <FontAwesomeIcon icon={solid('sitemap')} size="lg" fixedWidth />
                  </div>

                  <Col className="overflow-hidden">
                    <h6 className="mb-0">{organizations?.name}</h6>
                  </Col>

                  <div className="ps-3 text-end">
                    <Form.Check
                      inline
                      className='ms-3'
                      id={String(organizations?.id)}
                      type="checkbox"
                      checked={newDevice?.organization?.tenantId == organizations?.tenantId}
                      onChange={handleChekedOrganization(index)}
                    />
                  </div>
                </ListGroup.Item>
              )) : <></>}
            </ListGroup>

          </Modal.Body>

          <Modal.Footer>
            <Button variant="light" className="border" size="sm" onClick={handleAssignTenantModalClose}>{t('common.cancel')}</Button>
            <Button variant="success" size="sm" type="submit">{t('common.confirm')}</Button>
          </Modal.Footer>
        </Form>
      </Modal>

    </Container>
  )
}
